<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/foreword">Foreword, by Jerry Morelock</a></p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">1. Policing the Indian Frontier and Guarding Kansas Territory (1744–1861)</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Ad Astra Per Aspera: The Civil War (1861–1865)</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. The Soldier State: The Indian Wars and Westward Expansion (1866–1899)</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. War: Hot, Cold and Beyond (1900–Present)</span></p>
<p class="toc1"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4c6786a2